import { Input } from "@/components/ui/baseUi/input"
import { word } from "@modules/core/utils/i18n"
import { SearchIcon, XIcon } from "lucide-react"
import { type ChangeEventHandler } from "react"

export type MessageSearchInputProps = {
  onFocus: () => void
  search: {
    onChange: ChangeEventHandler<HTMLInputElement>
    value?: string
    loading?: boolean
    onReset: () => void
  }
}

export const MessageSearchInput: React.FC<MessageSearchInputProps> = ({ onFocus, search }) => {
  return (
    <div className="mb-1 flex w-full justify-center">
      <div className="relative w-68">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
          <SearchIcon className="size-4 text-neutral-500" color="currentColor" />
        </div>

        <Input
          id="search"
          onChange={search.onChange}
          placeholder={word("chat.search.placeholder")}
          value={search.value}
          className="w-full pl-9"
          defaultValue={search.value}
          onFocus={onFocus}
        />
        {search.value && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            <XIcon
              className="size-4 cursor-pointer text-neutral-500"
              color="currentColor"
              onClick={() => search.onChange({ target: { value: "" } } as React.ChangeEvent<HTMLInputElement>)}
            />
          </div>
        )}
      </div>
    </div>
  )
}
